import type { ReactNode } from 'react'

import type { QueryView } from '@krp/client-runtime'
import { Button, StatusMessage } from '@krp/ui-kit'

/**
 * Не-«готовые» состояния запроса одинаково во всех окнах UC1b: загрузка,
 * пусто, нет входа, нет доступа, недоступно, ошибка. Текст сервера — дословно
 * (ADR-8), корреляция — для отчёта. `extra` — дополнительное действие (например,
 * «Начать выдачу заново» при просроченном курсоре).
 */
export function QueryState({
  query,
  emptyText,
  onRetry,
  extra,
}: {
  query: QueryView
  emptyText: string
  onRetry: () => void
  extra?: ReactNode
}) {
  const meta = query.error !== null ? `Код: ${query.error.code}` + (query.error.correlationId !== null ? ` · запрос ${query.error.correlationId}` : '') : undefined
  const actions = (
    <>
      <Button variant="secondary" onClick={onRetry}>
        Повторить
      </Button>
      {extra}
    </>
  )
  switch (query.status) {
    case 'idle':
    case 'loading':
      return <StatusMessage kind="loading" title="Загрузка…" />
    case 'empty':
      return <StatusMessage kind="empty" title={emptyText} />
    case 'unauthorized':
      return <StatusMessage kind="unauthorized" title="Сессия завершена" text="Войдите снова, чтобы продолжить." />
    case 'forbidden':
      return (
        <StatusMessage kind="forbidden" title="Нет доступа" text={query.error?.message} {...(meta ? { meta } : {})} />
      )
    case 'unavailable':
      return (
        <StatusMessage
          kind="unavailable"
          title="Служба недоступна"
          text={query.error?.message}
          {...(meta ? { meta } : {})}
          action={actions}
        />
      )
    case 'error':
      return (
        <StatusMessage
          kind="error"
          title="Ошибка"
          text={query.error?.message}
          {...(meta ? { meta } : {})}
          action={actions}
        />
      )
    case 'ready':
      return null
  }
}
